import { render, staticRenderFns } from "./PotreeMeasurementsApp.vue?vue&type=template&id=05bf580a"
import script from "./PotreeMeasurementsApp.vue?vue&type=script&lang=js"
export * from "./PotreeMeasurementsApp.vue?vue&type=script&lang=js"
import style0 from "./PotreeMeasurementsApp.vue?vue&type=style&index=0&id=05bf580a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports